'use client';

import { Button, IcDownload, Typography } from '@musinsa/mds';

interface VisitorSecondaryButtonProps {
  status: 'AVAILABLE' | 'RECEIVED' | 'EXHAUSTED' | 'EXPIRED';
  disabled?: boolean;
  onReceive?: () => void;
}

/**
 * 방문자(isOwner=false) 헤더 카드의 우측 secondary 버튼.
 * - AVAILABLE: 검정 "쿠폰 받기" (onReceive 호출)
 * - RECEIVED: disabled "쿠폰 발급 완료"
 * - EXHAUSTED: disabled "쿠폰 소진"
 * - EXPIRED: null (큐레이션 샵 버튼만 노출)
 *
 * 색상은 MDS Button 의 `text-white` / `disabled:text-gray-400` cascade 에 위임:
 * - Typography: colorScheme 미지정 → 부모 text-* 상속
 * - IcDownload: strokeColor="strokeCurrent" → currentColor 상속
 */
export const VisitorSecondaryButton = ({
  status,
  disabled = false,
  onReceive,
}: VisitorSecondaryButtonProps) => {
  if (status === 'EXPIRED') return null;

  if (status === 'AVAILABLE') {
    return (
      <Button
        variant="primary"
        className="w-full"
        size={32}
        disabled={disabled}
        onClick={onReceive}
      >
        <IcDownload width={16} height={16} strokeColor="strokeCurrent" />
        <Typography variant="body13pxMed" className="ml-0.5">
          쿠폰 받기
        </Typography>
      </Button>
    );
  }

  const text = status === 'RECEIVED' ? '쿠폰 발급 완료' : '쿠폰 소진';
  return (
    <Button variant="primary" className="w-full" size={32} disabled>
      <IcDownload width={16} height={16} strokeColor="strokeCurrent" />
      <Typography variant="body13pxMed" className="ml-0.5">
        {text}
      </Typography>
    </Button>
  );
};
